export default __webpack_public_path__ + "static/AmericanaBT-Italic-2011cec9c9415b44c46e1ddc056a9c88.woff";